import { Component, ViewEncapsulation, model, output } from '@angular/core';

import { ApIconComponent } from '@ap/icon';

@Component({
    selector: 'ap-list-item-accordion',
    templateUrl: './list-item-accordion.html',
    styleUrls: ['./list-item-accordion.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIconComponent]
})
export class ApListItemAccordionComponent {
    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     */
    public readonly itemClicked = output<void>();

    /**
     * Accordion opened by default? Default is `false`
     */
    public readonly accordionOpen = model(false);

    protected getActionIcon(): string {
        return this.accordionOpen() ? 'chevron-up' : 'chevron-down';
    }

    protected onItemClicked(): void {
        this.itemClicked.emit();
        this.accordionOpen.set(!this.accordionOpen());
    }
}
